// Floating Buy Now Bar logic with jQuery (class-based)
jQuery(function ($) {
    if ($('.js-floating-buy-now').length === 0) return;

    var $floatingBar = $('.js-floating-buy-now');
    var $buyDropdownButton = $('.js-buy-button').first();
    var $footer = $('.page-footer').first();

    function showBar() {
        $floatingBar.addClass('is-visible');
    }
    function hideBar() {
        $floatingBar.removeClass('is-visible');
        jQuery('.buy-floating-menu').removeClass('is-open');
    }

    function checkButtonVisibility() {
        // If button is not in DOM or not visible, hide bar
        if ($buyDropdownButton.length === 0 || !$buyDropdownButton.is(':visible')) {
            hideBar();
            return false;
        }
        return true;
    }

    function isFooterInView() {
        if ($footer.length === 0 || !$footer.is(':visible')) return false;
        var footerRect = $footer[0].getBoundingClientRect();
        // Footer is in view if any part of it is visible in the viewport
        return (
            footerRect.top < window.innerHeight &&
            footerRect.bottom > 0
        );
    }

    function checkScrollPosition() {
        if (!checkButtonVisibility()) return;
        var buttonRect = $buyDropdownButton[0].getBoundingClientRect();
        // If button is in view (any part), hide bar
        if (buttonRect.bottom >= 0) {
            hideBar();
            return;
        }
        // If footer is in view, hide bar
        if (isFooterInView()) {
            hideBar();
            return;
        }
        // Otherwise, show bar
        showBar();
    }

    // Initial check
    checkScrollPosition();

    // Listen for scroll and resize
    $(window).on('scroll resize orientationchange', function () {
        checkScrollPosition();
    });

    jQuery('.js-floating-buy-button').on('click', function () {
        jQuery(this).siblings('.buy-floating-menu').toggleClass('is-open');
    });
});
